import { ReactElement } from 'react'
import { useSetAtom } from 'jotai'
import { Account } from '@syf-api-library/credit-accounts'

import config from 'const/config'
import clearSessionStorage from 'helpers/clearSessionStorage'
import handleRevokeAccessToken from 'helpers/handleRevokeAccessToken'
import redirectToUrl from 'helpers/redirectToUrl'
import i18n from 'strings/i18n'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import featureFlags from 'const/featureFlags'
import { Button } from './subcomponents'

interface CollectionsPaymentButtonProps {
  account: Account
  className?: string
  buttonText: 'paymentPlan' | 'paymentOptions'
  dataType?: string
}

const CollectionsPaymentButton = ({
  account,
  className,
  buttonText,
  dataType
}: CollectionsPaymentButtonProps): ReactElement => {
  const updateModalStatus = useSetAtom(modalStatusAtom)
  const setSelectedAccount = useSetAtom(selectedAccountAtom)

  const accountId = account.info['cipher.accountId']
  const collectionsButtonId = `collections-${accountId}`

  const handleOnClick = async () => {
    if (featureFlags.isDigitalCollectionsExperienceEnabled) {
      updateModalStatus('DigitalCollections', collectionsButtonId)
      setSelectedAccount(accountId)
    } else {
      const languageId = localStorage.getItem('language')
      await handleRevokeAccessToken()
      clearSessionStorage()
      redirectToUrl(
        `${config.DCH_HOST_NAME}/?account=${accountId}&lang=${languageId}`
      )
    }
  }

  return (
    <Button
      buttonType="secondary"
      className={className}
      onClick={handleOnClick}
      data-test="collection-payment-button"
      data-type={dataType}
      data-reason="view payment options"
      data-object="button"
      data-analytics="clicktrackingevent"
    >
      {i18n({ button: buttonText })}
    </Button>
  )
}

export default CollectionsPaymentButton
